export default function checkProcessedStatus(el, attr) {
  return el.hasAttribute(`data-wui-${attr}-processed`);
}
